import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface LogoutConfirmationProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutConfirmation = ({ show, onClose, onConfirm }: LogoutConfirmationProps) => {
    const [loading, setLoading] = useState<any>(false)
    const handleLogout = async () => {
      setLoading(true);
      try {
        await onConfirm(); // assume onConfirm is async
        onClose(); // close modal after successful logout
      } catch (error) {
        console.error('Logout failed:', error);
      } finally {
        setLoading(false);
      }
    };
  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="modal-dialog custom-modal modal-dialog-centered" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
      <Modal.Body className="logout-modal-body">
        <div className="logout-icon">
          <i className="bi bi-box-arrow-right text-white fs-1"></i>
        </div>
        <h4 className="logout-title">Confirm Logout</h4>
        <p className="logout-text">Are you sure you want to logout?</p>
        <div className="logout-buttons">
          <Button className="logout-btn " onClick={handleLogout} disabled={loading}>
          {loading ? 'Wait' : 'Logout'}
          </Button>
          <Button className="cancel-btn" onClick={onClose} >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutConfirmation;
